// extracted by mini-css-extract-plugin
export var button = "_fh-4";
export var hasDarkBackground = "_fh-7";
export var hasLightBackground = "_fh-6";
export var iconWrapper = "_fh-0";
export var large = "_fh-2";
export var medium = "_fh-1";
export var small = "_fh-5";
export var xsmall = "_fh-3";